import { fabric } from 'fabric'

export interface Point {
  x: number
  y: number
}

export interface LabelParams {
  label: string
  rectOverride?: fabric.Rect
  groupOverride?: fabric.Group
  font?: string
}

const Label = (): {
  getTextAttribute: (label: string) => {
    width: number
    height: number
  }
  createLabel: (params: LabelParams) => fabric.Group
} => {
  const TextObjectBase = {
    fontSize: 18,
    originX: 'center',
    originY: 'center',
    fontFamily: 'GT Walsheim Pro Regular',
    objectCaching: true,
  }

  const TextContainerBase = {
    originX: 'center',
    originY: 'center',
    rx: 5,
    ry: 5,
    fill: '#fff',
    objectCaching: true,
  }

  const LabelGroupBase = {
    selectable: false,
    type: 'labelGroup',
    objectCaching: true,
  }

  const getTextAttribute = (label: string) => {
    const textObject = new fabric.Text(label, TextObjectBase)
    return {
      width: textObject.getScaledWidth() + 40,
      height: textObject.getScaledHeight() + 15,
    }
  }

  const createLabel = ({
    label,
    rectOverride,
    groupOverride,
    font,
  }: LabelParams) => {
    const textObject = new fabric.Text(label, TextObjectBase)
    if (font) {
      textObject.fontFamily = font
    }
    const textContainer = new fabric.Rect({
      ...TextContainerBase,
      width: textObject.getScaledWidth() + 40,
      height: textObject.getScaledHeight() + 15,
      ...(rectOverride || {}),
    })
    return new fabric.Group([textContainer, textObject], {
      ...LabelGroupBase,
      width: textObject.getScaledWidth() + 40,
      height: textObject.getScaledHeight() + 15,
      ...(groupOverride || {}),
    })
  }

  return {
    createLabel,
    getTextAttribute,
  }
}

export default Label
